<div class="my-wallet">
  <div class="row">
    <div class="col-md-12">
      <div class="heading_32 mb-4">Payment Methods</div>
    </div>
    <div class="col-md-12">
      <div class="amount_balance">
        <div class="select_payment_option d-flex align-items-center">
          <div class="paymnt_option pointer"
            (click)="selectedPayMethod = 'upi'"
            [ngClass]="{ 'pay-selected': selectedPayMethod == 'upi' }">
            <div>

              <img
                src="https://tripxoxo-prod.s3.ap-south-1.amazonaws.com/tripxoxo_prod/assets/images/upi-icon.png"
                style="height: 50px;margin-bottom: 8px;" class="img-fluid"
                alt>
              <div class="description_16 color_13">UPI</div>
            </div>
          </div>
          <div class="paymnt_option pointer" (click)="selectedPayMethod = 'card'"
            [ngClass]="{ 'pay-selected': selectedPayMethod == 'card' }">
            <div>
              <svg xmlns="http://www.w3.org/2000/svg"
                style="margin-bottom: 8px;" width="50" height="50"
                viewBox="0 0 36 36" fill="none">
                <path
                  d="M33.6753 23.7732L8.9163 28.1389C7.38658 28.4086 5.92788 27.3872 5.65816 25.8575L2.93284 10.4017C2.66312 8.87194 3.68455 7.41324 5.2142 7.14352L29.9732 2.77781C31.5029 2.5081 32.9616 3.52953 33.2313 5.05917L35.9567 20.5151C36.2264 22.0447 35.205 23.5035 33.6753 23.7732Z"
                  fill="#3555A2" />
                <path
                  d="M29.9732 2.77781L17.5938 4.96067L21.2958 25.9561L33.6753 23.7733C35.205 23.5035 36.2264 22.0448 35.9566 20.5151L33.2313 5.05924C32.9617 3.52953 31.503 2.5081 29.9732 2.77781Z"
                  fill="#1B3555" />
                <path
                  d="M27.4219 33.2656H2.8125C1.25923 33.2656 0 32.0063 0 30.4531V15.1448C0 13.5915 1.25923 12.3323 2.8125 12.3323H27.4219C28.9751 12.3323 30.2344 13.5915 30.2344 15.1448V30.4531C30.2344 32.0063 28.9751 33.2656 27.4219 33.2656Z"
                  fill="#53D8E3" />
                <path
                  d="M27.4219 12.3323H15.1172V33.2656H27.4219C28.9751 33.2656 30.2344 32.0063 30.2344 30.4531V15.1448C30.2344 13.5915 28.9751 12.3323 27.4219 12.3323Z"
                  fill="#18A8C9" />
                <path d="M0 17.1169H30.2344V21.9017H0V17.1169Z"
                  fill="#ECF6FD" />
                <path
                  d="M8.37363 28.6221H3.58887C3.0064 28.6221 2.53418 29.0943 2.53418 29.6768C2.53418 30.2592 3.0064 30.7314 3.58887 30.7314H8.37363C8.9561 30.7314 9.42832 30.2592 9.42832 29.6768C9.42832 29.0943 8.9561 28.6221 8.37363 28.6221Z"
                  fill="#EAF6FF" />
                <path d="M15.1172 17.1169H30.2344V21.9017H15.1172V17.1169Z"
                  fill="#D6E8FE" />
              </svg>
              <div class="description_16 color_13">Card</div>
            </div>
          </div>
          <div class="paymnt_option pointer"
            (click)="selectedPayMethod = 'net_banking'"
            [ngClass]="{ 'pay-selected': selectedPayMethod == 'net_banking' }">
            <div>
              <img
                src="https://tripxoxo-prod.s3.ap-south-1.amazonaws.com/tripxoxo_prod/assets/images/online-banking.webp"
                style="height: 50px;margin-bottom: 8px;"
                class="img-fluid" alt>
              <div class="description_16 color_13">Net Banking</div>
            </div>
          </div>
          <div class="paymnt_option pointer"
            (click)="selectedPayMethod = 'wallet'; setWalletPay()"
            [ngClass]="{ 'pay-selected': selectedPayMethod == 'wallet' }">
            <div>
              <img
                src="https://tripxoxo-prod.s3.ap-south-1.amazonaws.com/tripxoxo_prod/assets/images/cash.webp"
                style="height: 50px;margin-bottom: 8px;" class="img-fluid"
                alt>
              <div class="description_16 color_13">tX Wallet</div>
            </div>
          </div>
          <div class="paymnt_option pointer"
            (click)="selectedPayMethod = 'value_design'"
            [ngClass]="{ 'pay-selected': selectedPayMethod == 'value_design' }">
            <div>
              <img
                src="https://tripxoxo-prod.s3.ap-south-1.amazonaws.com/tripxoxo_prod/assets/images/gift-card.png"
                style="height: 50px;margin-bottom: 8px;" class="img-fluid"
                alt>
              <div class="description_16 color_13">Gift Card</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>